import { Package, Route, PackageCheck } from "lucide-react";
import LuxSidebar from "./LuxSidebar";
import { useAuth } from "@/lib/auth";

const NAV = [
  { section: "Deliveries", to: "/courier",         label: "Pool",      icon: Package,      tid: "courier-nav-pool" },
  { section: "Deliveries", to: "/courier/route",   label: "My Route",  icon: Route,        tid: "courier-nav-route" },
  { section: "Deliveries", to: "/courier/history", label: "Completed", icon: PackageCheck, tid: "courier-nav-history" },
];

const TABS = [
  { id: "pool",    to: "/courier",         label: "Pool",      icon: Package,      tid: "courier-tab-pool" },
  { id: "route",   to: "/courier/route",   label: "Route",     icon: Route,        tid: "courier-tab-route" },
  { id: "history", to: "/courier/history", label: "Completed", icon: PackageCheck, tid: "courier-tab-history" },
];

export default function CourierNav({ activeTabId = "pool" }) {
  const { profile } = useAuth();
  return <LuxSidebar items={NAV}
    subtitle={profile?.partner_name ? `${profile.partner_name} · Courier` : "Courier Console"}
    footer="You see only room and package — contents are private"
    testidPrefix="courier-nav" homePath="/courier"
    tabs={TABS} activeTabId={activeTabId} />;
}
